import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { titleCaseChange } from "../../../Components/Functions/changeFirstLetterUpperCase";

const tableHead = [
  "Sr.",
  "Project",
  "Vendor / Business Name",
  "VENDOR RFQ DATE",
  "Actions",
];
const AllRfqTable = ({ PO = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    id = getId(id);
    navigate(`/rfq/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {PO?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.rfqNumber}>
                <td>{Index}</td>
                {/* <td>{getId(item?.rfqNumber)}</td> */}
                <td>
                  {titleCaseChange(item?.projectClientName) ||
                    titleCaseChange(item?.projectBusinessName) ||
                    "N/A"}
                </td>
                <td>
                  {titleCaseChange(item?.businessName) ||
                    titleCaseChange(item?.contactPersonName) ||
                    "N/A"}
                </td>
                <td>{item?.vendorQuotationOrderDate || "N/A"}</td>
                {/* <td>{item?.businessName || "N/A"}</td> */}
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.rfqNumber)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default AllRfqTable;
